<!-- eslint-disable vue/no-mutating-props -->
<template>
    <div class="Firma_detay">
        <AppMain>





            <div class="nk-content ">
        <div class="container-fluid">
            <div class="nk-content-inner">
                <div class="nk-content-body">
                    <div class="nk-block-head nk-block-head-sm">
                        <div class="nk-block-between g-3">
                            <div class="nk-block-head-content">

                            

                                <h3 class="nk-block-title page-title">Firma  / <strong class="text-primary small">{{ firmalar.unvan }}</strong></h3>
                                <div class="nk-block-des text-soft">
                                    <ul class="list-inline">
                                        <li>Firma  ID: <span class="text-base">{{ firmalar.id }}</span></li>
                                        <li>Güncelleme Tarihi: <span class="text-base">{{ firmalar.duzenleme_tarih }}</span></li>
                                    </ul>
                                </div>
                            </div>
                            <div class="nk-block-head-content">
                                <router-link to="/firmalar"  class="btn btn-outline-light bg-white d-none d-sm-inline-flex"><em
                                        class="icon ni ni-arrow-left"></em><span>Firmalar</span>
                                    </router-link>
                                  </div>
                        </div>
                    </div>
                    <div class="nk-block">
                        <div class="card card-bordered">
                            <div class="card-aside-wrap">
                                <div class="card-content">
                                    <ul class="nav nav-tabs nav-tabs-mb-icon nav-tabs-card">
                                        
                                        <li class="nav-item">
                                            <a  href="#" :class="{ 'active': aktifSekme === 'bilgiler','nav-link':true}"
                                            @click="aktifSekmeDegistir('bilgiler')">
                                                <em class="icon ni ni-user-circle"></em>
                                                <span>Firma Bilgileri</span>
                                            </a>
                                        </li>

                                        

                                        
                                    <li class="nav-item">
                                                    <a  href="#" :class="{ 'active': aktifSekme === 'kisiler','nav-link':true}"
                                                    @click="aktifSekmeDegistir('kisiler')">
                                                        <em class="icon ni ni-update"></em>
                                                        <span>Kişiler</span>
                                                    </a>
                                                </li>
                                    
                                    <li class="nav-item">
                                                    <a  href="#" :class="{ 'active': aktifSekme === 'gorusmebilgiler','nav-link':true}"
                                                    @click="aktifSekmeDegistir('gorusmebilgiler')">
                                                        <em class="icon ni ni-update"></em>
                                                        <span>Görüşme Bilgiler</span>
                                                    </a>
                                                </li>
                                    


                                        
                                   
                                        

                                     
                                        
                                     
                                        <li class="nav-item nav-item-trigger d-xxl-none">
                                            <a href="#" class="toggle btn btn-icon btn-trigger" data-target="userAside">
                                            <em class="icon ni ni-user-list-fill"></em></a>
                                        </li>
                                    </ul>

                               
                                    <div class="card-inner" v-show="aktifSekme === 'bilgiler'">
                                        <div class="nk-block">
                                            <div class="nk-block-head">
                                                <h5 class="title">Firma Bilgileri</h5>
                                               
                                            </div>
                                            <div class="profile-ud-list">
                                                


                                                
                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Ünvan </span><span class="profile-ud-value">{{ firmalar.unvan }}</span></div>
                                                                </div>
                                    
                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Telefon </span><span class="profile-ud-value">{{ firmalar.telefon }}</span></div>
                                                                </div>
                                    
                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">E-mail </span><span class="profile-ud-value">{{ firmalar.email }}</span></div>
                                                                </div>
                                    
                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Adres </span><span class="profile-ud-value">{{ firmalar.adres }}</span></div>
                                                                </div>
                                    
                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Not </span><span class="profile-ud-value">{{ firmalar.not }}</span></div>
                                                                </div>
                                    
                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Ülke </span><span class="profile-ud-value">{{ firmalar.ulke }}</span></div>
                                                                </div>
                                    
                                    
                                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Logo</span><span class="profile-ud-value">     <img 
    
                                                                    class="rounded img-cover mb-2 h-50" 
                                                                    :src="$globalVariable.uploadUrl + firmalar.logo" 
                                                                    alt="Kartvizit Ön Görsel" 
                                                                /></span></div>
                                                                </div>   
                                    
                                                 
                                                    

                                            </div>
                                        </div>
                                        <div class="nk-block">
                                            <div class="nk-block-head nk-block-head-line">
                                                <h6 class="title overline-title text-base">Kayıt Bilgileri</h6>
                                            </div>
                                            <div class="profile-ud-list">
                                                <div class="profile-ud-item">
                                                    <div class="profile-ud wider"><span class="profile-ud-label">Oluşturma Tarihi</span><span class="profile-ud-value">{{ firmalar.olusturma_tarih }}</span></div>
                                                </div>
                                                <div class="profile-ud-item">
                                                    <div class="profile-ud wider"><span class="profile-ud-label">Son Düzenleme Tarihi</span><span class="profile-ud-value">{{ firmalar.duzenleme_tarih }}</span>
                                                    </div>
                                                </div>
                                                
                                            </div>
                                        </div>
                                        <div class="nk-divider divider md"></div>
                                      
                                    </div>
                                    

                                    
                                    
                                    <div class="card-inner" v-show="aktifSekme === 'kisiler'">
                                        <div class="nk-block">
                                       

                                            <div class="d-flex justify-content-between mt-4 mb-2">
                                                    <h6>Kişiler</h6>
                                                    <a  @click="kisiler_ekle" class="btn btn-primary" >
                                                        <span>Kişi Ekle</span>
                                                        <em class="icon ni ni-plus"></em>
                                                    </a>
                                                </div>

                                                <kisiCard :kisiler="kisiler" :duzenle="kisiler_duzenle" :detay="kisiler_duzenle"   :formKaydetSonrasi="firmalarDetayGetir"  @update:kisiler="kisilerGuncelle" />


                                                <div class="modal fade modal-close-out show" style="display: block;" v-if="kisiler.modal">
                                                <div class="modal-dialog modal-dialog-centered">
                                                <div class="modal-content">
                                                    <div class="modal-header">
                                                    <h5 class="modal-title" v-if="kisiler.islem == 'ekle'"> Yeni Kişi Ekle </h5>
                                                    <h5 class="modal-title" v-if="kisiler.islem == 'duzenle'">Kişi Düzenleme </h5>
                                                    <button type="button" class="btn-close" @click="kisiler_iptal"></button>
                                                    </div>
                                                    <div class="modal-body">

                                                        <kisiForm :formIslem="kisiler.islem" :formData="kisiler.secili"
                                                        :formKaydetSonrasi="musterilerDetayGetir" :formIptal="kisiler_iptal" />


                                                    </div>
                                                </div>

                                                </div>
                                                </div>
                                         
                                        </div>
                                    </div>
                                    
                                    <div class="card-inner" v-show="aktifSekme === 'gorusmebilgiler'">
                                        <div class="nk-block">
                                       

                                            <div class="d-flex justify-content-between mt-4 mb-2">
                                                    <h6>Görüşme Bilgiler</h6>
                                                    <a  @click="gorusmebilgiler_ekle" class="btn btn-primary" >
                                                        <span>Görüşme Bilgi Ekle</span>
                                                        <em class="icon ni ni-plus"></em>
                                                    </a>
                                                </div>

                                                <gorusmebilgiCard :gorusmebilgiler="gorusmebilgiler" :duzenle="gorusmebilgiler_duzenle"  :detay="gorusmebilgiler_duzenle"  :formKaydetSonrasi="firmalarDetayGetir"  @update:gorusmebilgiler="gorusmebilgilerGuncelle" />


                                                <div class="modal fade modal-close-out show" style="display: block;" v-if="gorusmebilgiler.modal">
                                                <div class="modal-dialog modal-dialog-centered">
                                                <div class="modal-content">
                                                    <div class="modal-header">
                                                    <h5 class="modal-title" v-if="gorusmebilgiler.islem == 'ekle'"> Yeni Görüşme Bilgi Ekle </h5>
                                                    <h5 class="modal-title" v-if="gorusmebilgiler.islem == 'duzenle'">Görüşme Bilgi Düzenleme </h5>
                                                    <button type="button" class="btn-close" @click="gorusmebilgiler_iptal"></button>
                                                    </div>
                                                    <div class="modal-body">

                                                        <gorusmebilgiForm :formIslem="gorusmebilgiler.islem" :formData="gorusmebilgiler.secili"
                                                        :formKaydetSonrasi="musterilerDetayGetir" :formIptal="gorusmebilgiler_iptal" />


                                                    </div>
                                                </div>

                                                </div>
                                                </div>
                                         
                                        </div>
                                    </div>
                                    
                          
                             
                                      



                                </div>
                                <div class="card-aside card-aside-right user-aside toggle-slide toggle-slide-right toggle-break-xxl toggle-screen-xxl"
                                    data-content="userAside" data-toggle-screen="xxl" data-toggle-overlay="true"
                                    data-toggle-body="true">
                                    <div class="card-inner-group" data-simplebar="init">
                                        <div class="simplebar-wrapper" style="margin: 0px;">
                                            <div class="simplebar-height-auto-observer-wrapper">
                                                <div class="simplebar-height-auto-observer"></div>
                                            </div>
                                            <div class="simplebar-mask">
                                                <div class="simplebar-offset" style="right: 0px; bottom: 0px;">
                                                    <div class="simplebar-content-wrapper" tabindex="0" role="region"
                                                        aria-label="scrollable content"
                                                        style="height: auto; overflow: hidden;">
                                                        <div class="simplebar-content" style="padding: 0px;">
                                                            <div class="card-inner">
                                                                <div class="user-card user-card-s2">
                                                                    <div class="user-avatar lg bg-primary"> 
                                                                         <img :src="$globalVariable.uploadUrl + firmalar.logo"
                                                                            @error="$globalVariable.varsayilanGorsel" class="img-fluid rounded-xl">
                                                                        </div>
                                                                    <div class="user-info">
                                                                        <div
                                                                            class="badge bg-outline-light rounded-pill ucap">
                                                                            {{ firmalar.unvan }}</div>
                                                                        <h5> {{ firmalar.unvan  }}</h5><span
                                                                            class="sub-text">{{ firmalar.unvan }}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="card-inner card-inner-sm">
                                                                <ul class="btn-toolbar justify-center gx-1">
                                                                    <li><a href="#" class="btn btn-trigger btn-icon"><em
                                                                                class="icon ni ni-shield-off"></em></a>
                                                                    </li>
                                                                    <li><a href="#" class="btn btn-trigger btn-icon"><em
                                                                                class="icon ni ni-mail"></em></a></li>
                                                                    <li><a href="#" class="btn btn-trigger btn-icon"><em
                                                                                class="icon ni ni-download-cloud"></em></a>
                                                                    </li>
                                                                   
                                                                    <li><a href="#"
                                                                            class="btn btn-trigger btn-icon text-danger"><em
                                                                                class="icon ni ni-na"></em></a></li>
                                                                </ul>
                                                            </div>
                                                        
                                                            <div class="card-inner">
                                                                <div class="row text-center">
                                                                    <div class="col-6">
                                                                        <div class="profile-stats"><span
                                                                                class="amount">firmalar</span><span
                                                                                class="sub-text">{{ firmalar.unvan }}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-6">
                                                                        <div class="profile-stats"><span
                                                                                class="amount">firmalar</span><span
                                                                                class="sub-text">{{ firmalar.unvan }}</span>
                                                                        
                                                                    </div>
                                                                  
                                                                </div>
                                                            </div>

                                           

                                                            <div class="card-inner">
                                                                <h6 class="overline-title-alt mb-2">Kayıt Bilgileri</h6>
                                                                <div class="row g-3">
                                                                    <div class="col-6"><span class="sub-text">Oluşturma Tarihi:</span><span>{{ firmalar.olusturma_tarih }}</span></div>
                                                                  
                                                                    <div class="col-6"><span class="sub-text">Son Düzenleme Tarihi:</span><span>{{ firmalar.duzenleme_tarih }}</span></div>
                                                                </div>
                                                            </div>
                                                          
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="simplebar-placeholder" style="width: auto; height: 815px;">
                                            </div>
                                        </div>
                                        <div class="simplebar-track simplebar-horizontal" style="visibility: hidden;">
                                            <div class="simplebar-scrollbar" style="width: 0px; display: none;"></div>
                                        </div>
                                        <div class="simplebar-track simplebar-vertical" style="visibility: hidden;">
                                            <div class="simplebar-scrollbar" style="height: 0px; display: none;"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
   
</div>









            </AppMain>
        </div>
</template>
  
<script>
import axiosCustom from "@/services/axiosCustom";
import { yetkiKontrol } from '@/services/yetkiKontrol';
import AppMain from "@/components/AppMain.vue";

    
import kisiCard from "@/components/kisiler/kisiCard.vue";
import kisiForm from "@/components/kisiler/kisiForm.vue";
    
import gorusmebilgiCard from "@/components/gorusmebilgiler/gorusmebilgiCard.vue";
import gorusmebilgiForm from "@/components/gorusmebilgiler/gorusmebilgiForm.vue";



export default {
    name: "firmalarDetayView",
    components: {
        AppMain,
            
        kisiCard, 
        kisiForm,
            
        gorusmebilgiCard, 
        gorusmebilgiForm,
        
    },
    data() {
        return {
            firmalar: [],
           
            aktifSekme: 'bilgiler',
            hareketSayfadaKayit: 10,
            hareketSeciliSayfa: 1,

            
            kisiler: {
                tumu: [],
                secili: null,
                seciliSayfa: 1,
                sayfadaKayit: 5,
                arananKelime: "",
                islem: 'ekle',
                modal: false,
            },
            
            gorusmebilgiler: {
                tumu: [],
                secili: null,
                seciliSayfa: 1,
                sayfadaKayit: 5,
                arananKelime: "",
                islem: 'ekle',
                modal: false,
            },
            
          
            
            yuklenmisDosyalar: [],
            dosyalarEkleModal: false,
            seciliDosyalar:[],

            isUploading: false,
            uploadProgress: 0,
            uploadFileName:'',
            


        };
    },
    mounted() {
  
        this.firmalarDetayGetir();
    },

    methods: {
        yetki_kontrol(yetki) {
            return yetkiKontrol(yetki);
        },

        firmalarDetayGetir() {
            const id = this.$route.params.id;

            axiosCustom
                .get(`firmalar/detay/${id}`)
                .then((response) => {
                    this.firmalar = response.data;
           
                    
                    this.kisiler.tumu = response.data.kisiler;
                    this.kisiler.modal = false;
                    
                    this.gorusmebilgiler.tumu = response.data.gorusmebilgiler;
                    this.gorusmebilgiler.modal = false;
                    

                    
                    this.yuklenmisDosyalar = response.data.dosyalar;
                    

                    
                })
                .catch((error) => {
                    console.error("Veri çekme hatası: ", error);
                });
        },

    
        aktifSekmeDegistir(sekme) {
            this.aktifSekme = sekme;
            const id = this.$route.params.id;
            this.$router.push('/firmalar/'+id+'/'+sekme);
        },




        
        kisilerGuncelle(veriler) {
            this.kisiler = veriler;
        },
        kisiler_ekle() {
            this.kisiler.secili = {'firma':this.firmalar.id};
            this.kisiler.islem = "ekle";
            this.kisiler.modal = true;
            this.aktifSekmeDegistir("kisiler");
        },
        kisiler_duzenle(veri) {
            this.kisiler.secili = veri;
            this.kisiler.islem = "duzenle";
            this.kisiler.modal = true;
        },
   
        kisiler_iptal() {
            this.kisiler.secili = {};
            this.kisiler.modal = false;
        },
        
        gorusmebilgilerGuncelle(veriler) {
            this.gorusmebilgiler = veriler;
        },
        gorusmebilgiler_ekle() {
            this.gorusmebilgiler.secili = {'firma':this.firmalar.id};
            this.gorusmebilgiler.islem = "ekle";
            this.gorusmebilgiler.modal = true;
            this.aktifSekmeDegistir("gorusmebilgiler");
        },
        gorusmebilgiler_duzenle(veri) {
            this.$router.push('/gorusmeform/'+veri.id);
        },
        gorusmebilgiler_iptal() {
            this.gorusmebilgiler.secili = {};
            this.gorusmebilgiler.modal = false;
        },
        


       

        
                   
        dosyalar_ekle() {
            this.dosyalarEkleModal = true;
            this.aktifSekmeDegistir("dosyalar");
        },
        dosyalar_iptal() {
            this.dosyalarEkleModal = false;
            this.aktifSekmeDegistir("dosyalar");
        },
        dosyalarIslem(eventOrIndex) {
        if (eventOrIndex instanceof Event) {
          // Dosyalar seçildiğinde
          const files = eventOrIndex.target.files;
          for (let i = 0; i < files.length; i++) {
            this.seciliDosyalar.push(files[i]);
          }
         
            } else {
            // Kaldır düğmesine basıldığında
            this.seciliDosyalar.splice(eventOrIndex, 1);
            }
        },
      
  async cokluDosyalarYukle() {
const CHUNK_SIZE = 1024 * 1024; // 1 MB

for (const file of this.seciliDosyalar) {
    const totalChunks = Math.ceil(file.size / CHUNK_SIZE);

    for (let chunk = 0; chunk < totalChunks; chunk++) {
        const start = chunk * CHUNK_SIZE;
        const end = Math.min(start + CHUNK_SIZE, file.size);

        const chunkData = file.slice(start, end);

        let formData = new FormData();
        formData.append("fileName", file.name);
        this.uploadFileNmae = file.name;
        formData.append("fileChunk", chunkData);
        formData.append("currentChunk", chunk);
        formData.append("totalChunks", totalChunks);

        try {
            await axiosCustom.post("firmalar/dosyalaryukle/" + this.firmalar.id, formData);
            this.isUploading = true;
         
            this.uploadProgress = (chunk * totalChunks) / 100;

           

        } catch (error) {
            console.error('Dosyalar yükleme hatası: ', error);
            this.$toast.error('Dosyalar yükleme hatası');
            // Handle error
            return;
        }
    }

  
}

// Tüm dosyaların tüm chunk'ları yüklendiyse, işlemi tamamla
this.isUploading = false;
this.uploadProgress = 100;

this.$toast.success("Dosyalar Yüklendi");
this.firmalarDetayGetir();
this.dosyalarEkleModal = false;
},

        async dosyalarSil(id) {
            const result = await this.$swal({
                title: "Emin misiniz?",
                text: "Bu işlemi geri alamayacaksınız!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Evet, sil!",
                cancelButtonText: "İptal",
            });

            if (result.isConfirmed) {
                try {
                await axiosCustom.post("firmalar/dosyalarsil/" + id);
                this.$toast.success("Dosyalar Silindi");
                this.firmalarDetayGetir();
                } catch (error) {
                console.error("Silme hatası: ", error);
                this.$toast.error("Silme hatası");
                }
            }
         },
      
        
         



    }
};
</script>
  

  